import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useCampaignsTable } from '@Modal/hooks/campaigns/useCampaignsTable';

export const CampaignsTitle: React.FC = () => {
  const { campaignTableFilters, handleClearCampaignTableFilters } = useCampaignsTable();
  const objectVals = Object.values(campaignTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="CampaignsTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Campaigns</Typography>
        </Stack>
        <AtLocator type="button" name="clearFilters">
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={handleClearCampaignTableFilters}
          >
            Clear filters
          </Button>
        </AtLocator>
      </Stack>
    </AtLocator>
  );
};
